import posthog from 'posthog-js';
import type { AnalyticsTraits } from '../types';

/**
 * Identifies the current user in client-side analytics destinations.
 */
export function identifyClient(userId: string, traits: AnalyticsTraits = {}): void {
  if (!userId) {
    return;
  }

  posthog.identify(userId, traits);
  const w = window as Window & { gtag?: (...args: unknown[]) => void };
  w.gtag?.('set', { user_id: userId });
}
